import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { motion } from "framer-motion";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { EASE } from "@/components/Reveal";

const Placeholder = ({ title, kicker }) => (
  <div data-testid="placeholder-page" className="bg-white min-h-screen">
    <Navbar />
    <section className="min-h-[80vh] flex items-center px-5 sm:px-8 pt-32 pb-24">
      <div className="mx-auto max-w-[1600px] w-full">
        <span className="text-[var(--orange)] text-xs font-bold uppercase tracking-[0.28em]">
          ✦ {kicker}
        </span>
        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: EASE }}
          className="mt-6 font-head text-5xl sm:text-7xl lg:text-8xl font-black uppercase kern-tight leading-none"
        >
          {title}
        </motion.h1>
        <p className="mt-8 max-w-lg text-black/60 text-lg">
          This page is coming soon. We're crafting it with the same tolerance as
          everything else we build.
        </p>
        <Link
          data-testid="back-home"
          to="/"
          className="group mt-12 inline-flex items-center gap-3 bg-[var(--cerra-fg)] text-white text-xs font-bold uppercase tracking-[0.22em] px-8 py-5 hover:bg-[var(--orange)] transition-colors duration-300"
        >
          <ArrowLeft size={16} className="transition-transform duration-300 group-hover:-translate-x-1" />
          Back to Studio
        </Link>
      </div>
    </section>
    <Footer />
  </div>
);

export default Placeholder;
